/**
 * Mobile Sticky-Leiste auf der Produktseite: erscheint, sobald das Warteliste-Feld
 * aus dem Bild gescrollt ist (die Eingabezeile), und führt per Klick dorthin zurück.
 */
(() => {
  const leiste = document.querySelector('[data-sticky-cta]');
  const block = document.getElementById('warteliste');
  const ziel = block?.querySelector('.e-wl__zeile') ?? block;
  if (!leiste || !ziel || !('IntersectionObserver' in window)) return;

  let sichtbar = true;
  const pruefen = () => {
    leiste.hidden = sichtbar || window.scrollY < 400;
  };

  // Oberer Rand abzüglich der festen Kopfzeile, damit die Leiste erscheint, sobald die Zeile unter ihr verschwindet.
  new IntersectionObserver(
    ([eintrag]) => {
      sichtbar = eintrag.isIntersecting;
      pruefen();
    },
    { rootMargin: '-72px 0px 0px 0px' }
  ).observe(ziel);
  window.addEventListener('scroll', pruefen, { passive: true });
})();
